<template>
  <a-modal
    title="标记沟通结果"
    :footer="null"
    v-model="visible"
    :destroyOnClose="true"
  >
    <a-form :form="form">
      <a-form-item label="沟通结果">
        <a-textarea
          :rows="6"
          placeholder="请填写沟通结果，如没有获取到职位原因是什么，已获取到职位，职位数量有多少"
          v-decorator="[
            'remark',
            {
              rules: [
                { required: true, message: '请填写沟通结果' },
                { min: 6, message: '至少填写6个字' }
              ]
            }
          ]"
        ></a-textarea>
      </a-form-item>
    </a-form>
    <a-row type="flex" :gutter="10" justify="end">
      <a-col>
        <a-button
          type="dashed"
          @click="
            waiting = true;
            save('COMMUNICATE');
          "
          :loading="waiting"
          >沟通中</a-button
        >
      </a-col>
      <a-col>
        <a-button
          @click="
            cancelLoading = true;
            save('FAILED');
          "
          :loading="cancelLoading"
          >{{ type === 'JOB' ? '未获取到职位' : '无效线索' }}</a-button
        >
      </a-col>
      <a-col>
        <a-button type="primary" @click="save('SUCCESS')" :loading="loading"
          >{{ type === 'JOB' ? '已获取到职位' : '有效线索' }}</a-button
        >
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import Api from "@/api";
import BaseModal from "@/components/base-modal";
export default {
  name: "JobMarkModal",
  extends: BaseModal,
  data() {
    return {
      form: this.$form.createForm(this),
      record: {},
      type: 'JOB'
    };
  },
  methods: {
    save(confirm) {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await Api.cash.checkJobStatus({
              type: confirm,
              body: values.remark,
              job_clue_id: this.record.id
            });
            this.close();
            this.$emit("ok");
          } catch (e) {
            this.initLoading();
          }
        } else {
          this.initLoading();
        }
      });
    },
    async show(record, type) {
      this.record = record;
      this.type = type;
      console.log(type , 'type');
      // let { communication } = await Api.cash.getJobCommunication({
      //   job_clue_id: record.id
      // });
      this.open();
      // await this.$nextTick();
      // this.form.setFieldsValue({
      //   remark: communication.body
      // });
    }
  }
};
</script>

<style scoped lang="scss"></style>
